enum RequestStastusEnum {
  APPROVED = 'approved',
  DENIED = 'denied',
  PENDING = 'pending',
  CANCELLED = 'cancelled',
}

export default RequestStastusEnum;
